import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(0.5),
      
    },
  },
  button: {
    maxWidth: "300px",
    color: "#002D55",
    borderColor: "#002D55",
    border: "1px solid",
    "&:hover": {
        backgroundColor: "#002d55",
        color: "#FFFFFF",
        borderColor: "#0062cc",
        boxShadow: "none"
      },
    "&:active": {
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
        backgroundColor: "#0062cc",
        borderColor: "#005cbf"
      },
    "&:focus": {
        boxShadow: "0 0 0 0.2rem rgba(0, 45, 85, 0.8)"
      }
  },
  
}));


 

export default function MultipleChoice() {
  const classes = useStyles();

  return (
    <Grid container direction="column" className={classes.root}>
      <Button className={classes.button} variant="outlined">
        question
      </Button>

      
    </Grid>
  );
}
